import useSWR from 'swr';
import API from '../api';
import { AgeBand, PlanAnswers, PlanResponse } from './types';

export const PLAN_KEY = '/plan';

// GET /plan vrací 204 (bez plánu) → data undefined/null.
const planFetcher = (url: string) =>
    API.get(url).then((res) => (res.status === 204 ? null : (res.data as PlanResponse)));

export function usePlan() {
    const { data, error, isLoading, mutate } = useSWR<PlanResponse | null>(PLAN_KEY, planFetcher);
    return { plan: data ?? null, error, isLoading, mutate };
}

export async function generatePlan(answers: PlanAnswers, ageBand: AgeBand): Promise<PlanResponse> {
    const res = await API.post<PlanResponse>('/plan', {
        answers,
        age_band: ageBand,
        budget_min: 60, // čas neřešíme; všechna cvičení 1–6 min, filtr délky nikdy nefiltruje
    });
    return res.data;
}
